const Emitter = require('tiny-emitter')
export const events = new Emitter()
